import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.background?.paper || '#fff',
    border: `1px solid ${palette.divider || '#e0e0e0'}`,
    borderRadius: 8
  },
  header: {
    padding: spacing(2),
    backgroundColor: palette.grey?.[50] || '#fafafa',
    borderBottom: `1px solid ${palette.divider || '#e0e0e0'}`
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1)
  },
  title: {
    fontWeight: 600
  },
  dragHandle: {
    cursor: 'grab',
    color: palette.text?.secondary || '#666',
    '&:active': {
      cursor: 'grabbing'
    }
  },
  deleteButton: {
    color: palette.error?.main || '#f44336',
    '&:hover': {
      backgroundColor: palette.error?.light || '#ffebee'
    }
  },
  formContainer: {
    flex: 1,
    padding: spacing(3),
    overflowY: 'auto',
    // Root-level style override for custom scrollbar styling
    // Overrides default browser scrollbar appearance for better UX
    /* Firefox */
    scrollbarWidth: 'thin',
    scrollbarColor: `${palette.grey?.[400] || '#a6a6a6'} ${palette.grey?.[100] || '#ebebeb'}`,
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '5px',
      backgroundColor: palette.grey?.[100] || '#ebebeb'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '5px',
      backgroundColor: palette.grey?.[400] || '#a6a6a6'
    }
  },
  emptyState: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing(4),
    backgroundColor: palette.grey?.[50] || '#fafafa',
    border: `2px dashed ${palette.divider || '#e0e0e0'}`,
    borderRadius: 8
  },
  emptyStateSubtitle: {
    marginTop: spacing(1)
  }
}))
